import {
  Box,
  Badge,
  Button,
  createStyles,
  Flex,
  getStylesRef,
  Group,
  Loader,
  Menu,
  Modal,
  MultiSelect,
  Paper,
  Progress,
  Select,
  Text,
  Textarea,
  TextInput,
  ScrollArea,
  SimpleGrid,
  Table,
  Tabs,
  Tooltip,
  Popover,
  ActionIcon,
  NumberInput,
  Avatar,
} from "@mantine/core";
import { DateInput, TimeInput } from "@mantine/dates";

import { useDisclosure } from "@mantine/hooks";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  IconSearch, IconPlus, IconClock, IconLayoutBoard,
} from "@tabler/icons-react";
import { FaPlus } from "react-icons/fa";
import { NewAddButton } from "../../../components/AddButton/NewAddButton";
import CustomBillingPagination from "../../../components/Pagination/CustomBillingPagination";
import RecordNotFound from "../../../components/RecordNotFound";
import ComplianceTaskModal from "../../../components/ComplianceTaskModal";
import { https } from "../../../http";
import swal from "sweetalert";
import {
  getOperationalTasks,
  updateOperationalTaskStatus,
  updateOperationalTask,
  deleteOperationalTask,
  getComplianceDashboard,
  getTaskInstances,
  updateTaskInstanceStatus,
  getWeeklyTaskBoard,
} from "../../../services/compliance";
import AddButton from "../../../components/AddButton";
import {
  IconSettingsPlus, IconChevronLeft, IconChevronRight, IconCheck,
  IconChartBar, IconClipboardList, IconChecklist, IconUrgent,
  IconCircleCheck, IconCircleFilled, IconEdit, IconTrash,
} from "@tabler/icons-react";
import TaskTable from "../../../components/TaskTable";
import CustomPagination from "../../../components/Pagination/CustomPagination";
import AddTaskModal from "../../../components/TaskTable/AddTaskModal";
import { getAllTasks, getTasks, getTaskTypes } from "../../../services/task";
import { TrackPageView } from "../../../config/mixpanelConfig";
import AddTaskReport from "./AddTaskReport";
import { getAllPatientsModal } from "../../../services/patient";
import { getAllFacilitiesModal } from "../../../services";
import { getAllStaff } from "../../../services/staff";
import AppNavbar from "../../../components/AppNavbar/AppNavbar";
import { getAllSignatures } from "../../../services/signature";
import { IoIosArrowDown } from "react-icons/io";
import { IoChevronBack, IoFilter } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";
import { DatePickerInput } from "@mantine/dates";
import moment from "moment";
// import TaskReportDrawer from "../../../components/TaskReportDrawer";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { Form8615ReportPdf } from "../../../components/Form8615Pdf";
import TaskReportDrawer from "../../../components/TaskReportDrawer";

const useStyles = createStyles((theme) => ({
  wrapper: {
    display: "flex",
  },
  content: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    overflowX: "auto",
  },
  btn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    gap: 10,
    // marginLeft: "auto",
    marginTop: 50,
  },
  mymodal: {
    width: 818,
    "& .mantine-Modal-inner": {
      padding: "0px !important",
    },
  },
  mwd: {
    width: "100%",
  },
  tableWrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100vh",
  },
  pagination: {
    margin: "1rem 0",
    display: "flex",
    alignItems: "end",
    justifyContent: "end",
  },
  btnIcon: {
    ref: getStylesRef("btnIcon"),
    background: "var(--app-primary)",
    borderRadius: 5,
    cursor: "pointer",
  },
  createMenuBtn: {
    padding: 12,
    cursor: "pointer",
    borderRadius: "8px",
    border: "1px solid var(--app-primary)",
    backgroundColor: "var(--app-primary)",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    height: 48,
    "& .arrowBox": {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      width: 30,
      borderLeft: "2px solid var(--app-on-primary)",
    },
  },

  menuDropdown: {
    padding: 8,
    borderRadius: 4,
    backgroundColor: "var(--app-surface)",
    boxShadow: "0 2px 8px 0 rgba(0, 0, 0, 0.10)",
  },
  menuDropdownItem: {
    padding: "4px 12px",
    ":hover": {
      backgroundColor: "var(--app-surface-2)",
      borderRadius: 4,
    },
  },
  filterBtn: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    "& .mantine-Menu-dropdown": {
      padding: "0 !important",
    },
  },
  box_header: {
    display: "flex",
    justifyContent: "space-between",
    padding: "16px 15px",
  },
  box_body: {
    display: "flex",
    flexDirection: "column",
    rowGap: "10px",
    background: "var(--app-bg)",
    padding: "15px",
    borderTop: "1px solid var(--app-border)",
    borderBottom: "1px solid var(--app-border)",
  },
  filterFields: {
    padding: "12px",
    background: "var(--app-surface)",
    border: "1px solid var(--app-border)",
    borderRadius: "8px",
  },
  btn_container: {
    display: "flex",
    justifyContent: "space-between",
    padding: "16px 15px",
  },
  filterCategoryList: {
    display: "flex",
    flexDirection: "column",
    gap: 0,
  },
  filterCategoryItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px 15px",
    cursor: "pointer",
    borderBottom: "1px solid var(--app-border)",
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 500,
    color: "var(--app-text)",
    "&:hover": {
      backgroundColor: "var(--app-surface-2)",
    },
  },
  activeFilterDot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "var(--app-primary)",
  },
  filterCategoryHeader: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "16px 15px",
    borderBottom: "1px solid var(--app-border)",
    cursor: "pointer",
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 600,
    color: "var(--app-text)",
  },
  activeFiltersBar: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 8,
    padding: "8px 20px",
  },
  filterChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "4px 10px",
    borderRadius: "16px",
    backgroundColor: "var(--app-surface-2)",
    border: "1px solid var(--app-border)",
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 500,
    color: "var(--app-text)",
    "& svg": {
      cursor: "pointer",
      color: "var(--app-text-muted)",
      "&:hover": {
        color: "var(--app-text)",
      },
    },
  },
  clearAllLink: {
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 500,
    color: "var(--app-primary)",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  pageTab: {
    padding: "10px 20px",
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 500,
    color: "var(--app-text-muted)",
    cursor: "pointer",
    borderBottom: "2px solid transparent",
    transition: "all 0.15s ease",
    "&:hover": { color: "var(--app-text)" },
  },
  pageTabActive: {
    color: "var(--app-text)",
    fontWeight: 600,
    borderBottom: "2px solid var(--app-primary)",
  },
  staffTaskRow: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "14px 16px",
    borderBottom: "1px solid var(--app-border)",
    "&:last-child": { borderBottom: "none" },
    "&:hover": { backgroundColor: "var(--app-surface-2)" },
  },
  statusPill: {
    cursor: "pointer",
    userSelect: "none",
    transition: "all 0.15s ease",
    "&:hover": { opacity: 0.8 },
  },
  // ── Operational-style Staff Tab Styles ──
  opStatCard: {
    padding: 20,
    borderRadius: 14,
    border: "1px solid var(--app-border)",
    backgroundColor: "var(--app-surface)",
    position: "relative",
    overflow: "hidden",
    transition: "box-shadow 0.2s",
    "&:hover": { boxShadow: "0 4px 12px rgba(0,0,0,0.06)" },
  },
  opStatAccent: {
    position: "absolute",
    left: 0,
    top: 0,
    bottom: 0,
    width: 4,
    borderRadius: "14px 0 0 14px",
  },
  opStatIconWrap: {
    width: 40,
    height: 40,
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  scoreCardTitle: {
    fontFamily: "Inter",
    fontSize: 13,
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    color: "var(--app-text-muted)",
    marginBottom: 8,
  },
  scoreCardValue: {
    fontFamily: "Inter",
    fontSize: 32,
    fontWeight: 700,
    lineHeight: 1.1,
  },
  scoreBar: {
    height: 8,
    borderRadius: 4,
    backgroundColor: "var(--app-surface-2)",
    overflow: "hidden",
    marginTop: 12,
  },
  "@keyframes pulseRed": {
    "0%": { boxShadow: "0 0 0 0 rgba(239,68,68,0.25)" },
    "70%": { boxShadow: "0 0 0 8px rgba(239,68,68,0)" },
    "100%": { boxShadow: "0 0 0 0 rgba(239,68,68,0)" },
  },
  opOverduePulse: {
    animation: "$pulseRed 2s infinite",
  },
  opStatusPill: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "4px 12px",
    borderRadius: 20,
    fontFamily: "Inter",
    fontSize: 12,
    fontWeight: 600,
    cursor: "pointer",
    userSelect: "none",
    transition: "all 0.15s ease",
    "&:hover": { filter: "brightness(0.95)", transform: "scale(1.03)" },
  },
  opTaskTypeBadge: {
    display: "inline-flex",
    alignItems: "center",
    padding: "3px 8px",
    borderRadius: 6,
    fontFamily: "Inter",
    fontSize: 10,
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.02em",
    whiteSpace: "nowrap",
  },
  opStaffAvatar: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "3px 10px 3px 3px",
    borderRadius: 20,
    border: "1px solid var(--app-border)",
    background: "var(--app-surface-2)",
    fontFamily: "Inter",
    fontSize: 12,
    fontWeight: 500,
    color: "var(--app-text)",
  },
  opStaffInitial: {
    width: 24,
    height: 24,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Inter",
    fontSize: 10,
    fontWeight: 700,
    color: "#FFF",
    flexShrink: 0,
  },
  opTableRow: {
    transition: "background 0.1s",
  },
  opOverdueRow: {
    borderLeft: "3px solid #FCA5A5",
    background: "#FEF2F2 !important",
  },
  opRelativeTime: {
    fontFamily: "Inter",
    fontSize: 11,
    fontWeight: 500,
    marginLeft: 4,
  },
  sectionTitle: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: 16,
    color: "var(--app-text)",
  },
  table: {
    borderRadius: 12,
    border: "1px solid var(--app-border)",
    overflow: "hidden",
    "& thead tr th": {
      backgroundColor: "var(--app-surface-2)",
      borderBottom: "1px solid var(--app-border)",
    },
  },
}));

export const taskAdlHiddenFields = {
  "Vital Signs": ["Pain Assessment", "Intake and Output Monitoring"],
  Bowel: ["Blood Pressure"],
  "Skin Care": [
    "Check Skin Integrity",
    "Check Boney Areas",
    "Apply cream/ointment as Prescribed",
    "Maintain good nutrition and fluid intake",
    "Perineal care with brief change",
    "Pressure relieving device",
    "Float Heals",
  ],
  Bed: [
    "Room Safety Tidy",
    "Call Light Access Check",
    "Bed Positioning",
    "Toe Nails/Finger Nails",
  ],
  Other: ["Family Communication Support", "Mood Observation"],
};

const TASK_FILTERS_STORAGE_KEY = "tasksListFilters";

const readStoredTaskFilters = () => {
  try {
    const raw = sessionStorage.getItem(TASK_FILTERS_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
};

const AllTasks = () => {
  const { tasksCount, taskTypes } = useSelector((state) => state?.task);
  const storedTaskFilters = readStoredTaskFilters();
  const [currentPage, setCurrentPage] = useState(
    storedTaskFilters?.currentPage || 1
  );
  const { profile } = useSelector((state) => state.profile);
  const { allDeletedFacilities } = useSelector((state) => state?.facility);
  const { allPatients } = useSelector((state) => state?.patient);
  const { allStaff } = useSelector((state) => state?.staff);

  // Page-level tab: "client" or "staff"
  const [searchParams, setSearchParams] = useSearchParams();
  const taskPageTab = searchParams.get("tab") || "client";
  const setTaskPageTab = (tab) => setSearchParams({ tab });

  // Staff task state
  const { operationalTasks, operationalTasksCount, operationalTasksLoading } = useSelector((state) => state?.compliance || {});
  const [staffTaskPage, setStaffTaskPage] = useState(1);
  const [staffTaskFilter, setStaffTaskFilter] = useState("all");
  const [staffTaskSearch, setStaffTaskSearch] = useState("");
  // Staff sub-tab: "all" | "calendar"
  const [staffSubTab, setStaffSubTab] = useState("all");
  // Weekly board state
  const [weeklyBoard, setWeeklyBoard] = useState(null);
  const [weeklyBoardLoading, setWeeklyBoardLoading] = useState(false);
  const [weekOffset, setWeekOffset] = useState(0);
  const complianceDashboard = useSelector((state) => state?.compliance?.dashboard) || null;
  const staffDashboard = complianceDashboard?.operational ?? {};
  const [
    TaskReportDrawerOpened,
    { open: TaskReportDrawerOpen, close: TaskReportDrawerClose },
  ] = useDisclosure(false);

  // Filter state (persisted in sessionStorage so it survives navigating into a
  // task and back; cleared only when the user resets/changes filters or the
  // browser session ends)
  const [activeFilters, setActiveFilters] = useState(
    storedTaskFilters?.activeFilters || {
      taskType: null,
      facility: null,
      client: null,
      staffFilter: null,
      dateRange: null,
    }
  );
  const [filterDropdownOpen, setFilterDropdownOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [tempTaskType, setTempTaskType] = useState(null);
  const [tempFacility, setTempFacility] = useState(null);
  const [tempClient, setTempClient] = useState(null);
  const [tempStaff, setTempStaff] = useState(null);
  const [dateRangeVal, setDateRangeVal] = useState([]);
  const [oneDayValue, setOneDayValue] = useState(null);

  useEffect(() => {
    getTasks(currentPage, "all", activeFilters);
  }, [currentPage, activeFilters]);

  // Persist filters/page/scroll position so they survive navigating into a
  // task (view/edit) and back to this list.
  useEffect(() => {
    try {
      const existing = readStoredTaskFilters() || {};
      sessionStorage.setItem(
        TASK_FILTERS_STORAGE_KEY,
        JSON.stringify({ ...existing, activeFilters, currentPage })
      );
    } catch (e) {
      // sessionStorage unavailable — filters simply won't persist
    }
  }, [activeFilters, currentPage]);

  // Restore scroll position once tasks for the restored page/filters have loaded
  useEffect(() => {
    if (!storedTaskFilters?.scrollY) return;
    const scrollY = storedTaskFilters.scrollY;
    const timeoutId = setTimeout(() => {
      window.scrollTo(0, scrollY);
    }, 0);
    return () => clearTimeout(timeoutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tasksCount]);

  // Only these routes are "inside" the Tasks module (view/edit a task) — when
  // the user goes back and forth between the list and these, filters should
  // persist. Leaving to any other module (Medication, Staff, etc.) should
  // clear the persisted filters.
  const TASK_INTERNAL_ROUTES = ["/home/view-task", "/home/edit-task"];

  // On unmount: if the user is navigating within the Tasks module, save the
  // scroll position so it can be restored; otherwise (navigating to a
  // different module) clear the persisted filters entirely.
  useEffect(() => {
    return () => {
      const nextPath = window.location.pathname;
      const stayingInTasksModule = TASK_INTERNAL_ROUTES.some((route) =>
        nextPath.startsWith(route)
      );
      try {
        if (stayingInTasksModule) {
          const existing = readStoredTaskFilters() || {};
          sessionStorage.setItem(
            TASK_FILTERS_STORAGE_KEY,
            JSON.stringify({ ...existing, scrollY: window.scrollY })
          );
        } else {
          sessionStorage.removeItem(TASK_FILTERS_STORAGE_KEY);
        }
      } catch (e) {
        // ignore
      }
    };
  }, []);

  useEffect(() => {
    TrackPageView("Task");
  }, []);

  useEffect(() => {
    getAllPatientsModal();
    getAllSignatures();
    getTaskTypes("all");
    getAllFacilitiesModal("withDeleted");
    getAllStaff("all");
  }, []);

  // Load weekly board data
  const loadWeeklyBoard = async (offset = 0) => {
    setWeeklyBoardLoading(true);
    try {
      const data = await getWeeklyTaskBoard(offset);
      setWeeklyBoard(data);
    } catch (e) {
      console.error("Failed to load weekly board:", e);
    }
    setWeeklyBoardLoading(false);
  };

  // Fetch staff tasks and dashboard stats when staff tab is active
  useEffect(() => {
    if (taskPageTab === "staff") {
      getOperationalTasks(staffTaskPage, 10, staffTaskFilter, staffTaskSearch);
      loadWeeklyBoard(weekOffset); // Load weekly data for stats
    }
  }, [taskPageTab, staffTaskPage, staffTaskFilter, staffTaskSearch]);

  useEffect(() => {
    if (taskPageTab === "staff") {
      getComplianceDashboard();
    }
  }, [taskPageTab]);

  // ── Staff Task Edit Modal state ──
  const [staffEditModalOpened, { open: openStaffEditModal, close: closeStaffEditModal }] = useDisclosure(false);
  const [editingStaffTask, setEditingStaffTask] = useState(null);

  const openEditTask = (task) => {
    setEditingStaffTask(task);
    openStaffEditModal();
  };

  const handleStaffStatusChange = async (taskId, currentStatus) => {
    const nextStatus = currentStatus === "not_started" ? "in_progress" : currentStatus === "in_progress" ? "complete" : "not_started";
    await updateOperationalTaskStatus(taskId, nextStatus);
    getOperationalTasks(staffTaskPage, 10, staffTaskFilter, staffTaskSearch);
    loadWeeklyBoard(weekOffset);
  };

  const handleStaffTaskDelete = async (taskId) => {
    const confirm = await swal({ title: "Delete Task?", text: "This action cannot be undone.", icon: "warning", buttons: ["Cancel", "Delete"], dangerMode: true });
    if (confirm) {
      await deleteOperationalTask(taskId);
      getOperationalTasks(staffTaskPage, 10, staffTaskFilter, staffTaskSearch);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "complete": return "green";
      case "in_progress": return "yellow";
      case "not_started": return "gray";
      default: return "gray";
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case "complete": return "Complete";
      case "in_progress": return "In Progress";
      case "not_started": return "Not Started";
      default: return status;
    }
  };

  // ── Operational-style helpers ──
  const getScoreColor = (s) => (s >= 80 ? "#10B981" : s >= 50 ? "#F59E0B" : "#EF4444");

  const formatTime12h = (time) => {
    if (!time) return "9:00 AM";
    if (time.includes("AM") || time.includes("PM")) return time;
    const [hh, mm] = time.split(":").map(Number);
    const period = hh >= 12 ? "PM" : "AM";
    const h12 = hh === 0 ? 12 : hh > 12 ? hh - 12 : hh;
    return `${h12}:${String(mm).padStart(2, "0")} ${period}`;
  };

  const opScheduleLabel = (t) => {
    if (t.scheduleType === "one_time") return t.dueDate ? `Due ${moment(t.dueDate).format("MMM DD, YYYY")}` : "One-time";
    if (t.recurrence?.frequency === "daily") return `Daily at ${formatTime12h(t.recurrence.timeOfDay)}`;
    if (t.recurrence?.frequency === "weekly") {
      const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      return `Weekly - ${days[t.recurrence.dayOfWeek || 0]} at ${formatTime12h(t.recurrence.timeOfDay)}`;
    }
    if (t.recurrence?.frequency === "monthly") return `Monthly - Day ${t.recurrence.dayOfMonth || 1} at ${formatTime12h(t.recurrence.timeOfDay)}`;
    return "\u2014";
  };

  const getRelativeTime = (t) => {
    if (t.status === "complete") return null;
    let dueDate = null;
    if (t.scheduleType === "one_time" && t.dueDate) {
      dueDate = moment(t.dueDate);
    } else if (t.recurrence?.timeOfDay) {
      const _timeParts = (t.recurrence.timeOfDay || "09:00").split(":");
      const hh = parseInt(_timeParts[0]) || 9;
      const mm = parseInt(_timeParts[1]) || 0;
      dueDate = moment().startOf("day").add(hh, "hours").add(mm || 0, "minutes");
      if (dueDate.isBefore(moment())) {
        if (t.recurrence.frequency === "daily") dueDate.add(1, "day");
        else if (t.recurrence.frequency === "weekly") dueDate.add(1, "week");
        else if (t.recurrence.frequency === "monthly") dueDate.add(1, "month");
      }
    }
    if (!dueDate) return null;
    const diff = dueDate.diff(moment());
    if (diff > 0) {
      const d = moment.duration(diff);
      if (d.asHours() < 1) return { text: `Due in ${Math.round(d.asMinutes())}m`, overdue: false };
      if (d.asHours() < 24) return { text: `Due in ${Math.round(d.asHours())}h`, overdue: false };
      return { text: `Due in ${Math.round(d.asDays())}d`, overdue: false };
    } else {
      const d = moment.duration(-diff);
      if (d.asHours() < 1) return { text: `Overdue by ${Math.round(d.asMinutes())}m`, overdue: true };
      if (d.asHours() < 24) return { text: `Overdue by ${Math.round(d.asHours())}h`, overdue: true };
      return { text: `Overdue by ${Math.round(d.asDays())}d`, overdue: true };
    }
  };

  const statusPillConfig = (status, isOverdue) => {
    if (isOverdue && status !== "complete") return { bg: "#FEF2F2", color: "#DC2626", dotColor: "#EF4444", label: "Overdue" };
    if (status === "complete") return { bg: "#F0FDF4", color: "#16A34A", dotColor: "#22C55E", label: "Complete" };
    if (status === "in_progress") return { bg: "#FFFBEB", color: "#D97706", dotColor: "#F59E0B", label: "In-Progress" };
    return { bg: "#F3F4F6", color: "#6B7280", dotColor: "#9CA3AF", label: "Not Started" };
  };

  const avatarColors = ["#6366F1", "#8B5CF6", "#EC4899", "#F59E0B", "#10B981", "#3B82F6", "#EF4444", "#14B8A6"];
  const getAvatarColor = (name) => {
    let hash = 0;
    for (let i = 0; i < (name || "").length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
    return avatarColors[Math.abs(hash) % avatarColors.length];
  };

  const cycleStaffStatus = async (taskId, currentStatus) => {
    const order = ["not_started", "in_progress", "complete"];
    const next = order[(order.indexOf(currentStatus) + 1) % order.length];
    await updateOperationalTaskStatus(taskId, next);
    getOperationalTasks(staffTaskPage, 10, staffTaskFilter, staffTaskSearch);
    getComplianceDashboard();
    loadWeeklyBoard(weekOffset);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const navigate = useNavigate();
  const { classes } = useStyles();
  const [opened, { open, close }] = useDisclosure(false);
  const [openedReport, { open: reportOpenModal, close: reportCloseModal }] =
    useDisclosure(false);
  const [reportType, setReportType] = useState(null);

  const openReportDrawer = (type) => {
    setReportType(type);
    TaskReportDrawerOpen();
  };

  // Filter helpers
  const hasActiveFilters =
    activeFilters.taskType ||
    activeFilters.facility ||
    activeFilters.client ||
    activeFilters.staffFilter ||
    activeFilters.dateRange;

  const getTaskTypeName = (id) => {
    const tt = taskTypes?.find((t) => t.id === id);
    return tt?.name || id;
  };

  const getFacilityName = (id) => {
    const fac = allDeletedFacilities?.facilities?.find((f) => f.id === id);
    return fac?.name || id;
  };

  const getClientName = (id) => {
    const patient = allPatients?.find((p) => p.id === id);
    return patient?.name || id;
  };

  const getStaffName = (id) => {
    const staff = allStaff?.find((s) => s.id === id);
    return (
      staff?.name ||
      `${staff?.firstName || ""} ${staff?.lastName || ""}`.trim() ||
      id
    );
  };

  const handleDateRange = (dates) => {
    if (dates[0] == null && dates[1] == null) {
      setDateRangeVal([]);
    } else {
      setDateRangeVal(dates);
    }
  };

  const handleDateChange = (date) => {
    setOneDayValue(date);
  };

  const handleApplyFilter = () => {
    const newFilters = { ...activeFilters };
    if (selectedCategory === "dateRange") {
      if (dateRangeVal?.length && dateRangeVal[0] && dateRangeVal[1]) {
        const startDate = moment(dateRangeVal[0]).startOf("day");
        const endDate = moment(dateRangeVal[1]).endOf("day");
        newFilters.dateRange = `${startDate.toISOString()},${endDate.toISOString()}`;
      } else if (oneDayValue) {
        const startDate = moment(oneDayValue).startOf("day");
        const endDate = moment(oneDayValue).endOf("day");
        newFilters.dateRange = `${startDate.toISOString()},${endDate.toISOString()}`;
      }
    }
    if (selectedCategory === "facility" && tempFacility) {
      newFilters.facility = tempFacility;
    }
    if (selectedCategory === "client" && tempClient) {
      newFilters.client = tempClient;
    }
    if (selectedCategory === "taskType" && tempTaskType) {
      newFilters.taskType = tempTaskType;
    }
    if (selectedCategory === "staff" && tempStaff) {
      newFilters.staffFilter = tempStaff;
    }
    setActiveFilters(newFilters);
    setCurrentPage(1);
    setFilterDropdownOpen(false);
    setSelectedCategory(null);
  };

  const handleResetAllFilters = () => {
    setActiveFilters({
      taskType: null,
      facility: null,
      client: null,
      staffFilter: null,
      dateRange: null,
    });
    setDateRangeVal([]);
    setOneDayValue(null);
    setTempTaskType(null);
    setTempFacility(null);
    setTempClient(null);
    setTempStaff(null);
    setSelectedCategory(null);
    setCurrentPage(1);
    setFilterDropdownOpen(false);
    try {
      sessionStorage.removeItem(TASK_FILTERS_STORAGE_KEY);
    } catch (e) {
      // ignore
    }
  };

  const handleRemoveFilter = (key) => {
    if (key === "dateRange") {
      setDateRangeVal([]);
      setOneDayValue(null);
    }
    setActiveFilters((prev) => ({ ...prev, [key]: null }));
    setCurrentPage(1);
  };

  const formatDateRange = (dr) => {
    if (!dr) return "";
    const [start, end] = dr.split(",");
    return `${moment(start).format("MM/DD/YY")} - ${moment(end).format(
      "MM/DD/YY"
    )}`;
  };

  const staffTasks = Array.isArray(operationalTasks) ? operationalTasks : [];

  return (
    <Box className={classes.content}>
      <AppNavbar title="Task" profile={profile} />
      <AddTaskModal
        opened={opened}
        onclose={(nType) => {
          close();
        }}
        title={"Add a New Task"}
      />

      {(
      <Box px={20} style={{ paddingBottom: 30, paddingTop: 10 }}>
        <Box className={classes.btn}>
          <Box className={classes.filterBtn}>
            <Menu
              width={350}
              shadow="md"
              radius={"md"}
              opened={filterDropdownOpen}
              position="bottom-start"
              onClose={() => {
                setFilterDropdownOpen(false);
                setSelectedCategory(null);
              }}
            >
              <Menu.Target title="Filter">
                <Button
                  size="md"
                  radius="md"
                  title="Filter"
                  leftIcon={<IoFilter />}
                  onClick={() => setFilterDropdownOpen(!filterDropdownOpen)}
                  color="gray"
                  variant="outline"
                >
                  Filter
                </Button>
              </Menu.Target>

              <Menu.Dropdown>
                {!selectedCategory ? (
                  <>
                    <Box className={classes.box_header}>
                      <Text size="lg" weight={500}>
                        Filter
                      </Text>
                      <Button
                        variant="unstyled"
                        p={0}
                        onClick={() => setFilterDropdownOpen(false)}
                      >
                        <RxCross2 />
                      </Button>
                    </Box>
                    <Box className={classes.filterCategoryList}>
                      <Box
                        className={classes.filterCategoryItem}
                        onClick={() => setSelectedCategory("dateRange")}
                      >
                        <Text>Date Range</Text>
                        {activeFilters.dateRange && (
                          <Box className={classes.activeFilterDot} />
                        )}
                      </Box>
                      <Box
                        className={classes.filterCategoryItem}
                        onClick={() => {
                          setSelectedCategory("facility");
                          setTempFacility(activeFilters.facility);
                        }}
                      >
                        <Text>Facility Name</Text>
                        {activeFilters.facility && (
                          <Box className={classes.activeFilterDot} />
                        )}
                      </Box>
                      <Box
                        className={classes.filterCategoryItem}
                        onClick={() => {
                          setSelectedCategory("client");
                          setTempClient(activeFilters.client);
                        }}
                      >
                        <Text>Client Name</Text>
                        {activeFilters.client && (
                          <Box className={classes.activeFilterDot} />
                        )}
                      </Box>
                      <Box
                        className={classes.filterCategoryItem}
                        onClick={() => {
                          setSelectedCategory("taskType");
                          setTempTaskType(activeFilters.taskType);
                        }}
                      >
                        <Text>Task Type</Text>
                        {activeFilters.taskType && (
                          <Box className={classes.activeFilterDot} />
                        )}
                      </Box>
                      <Box
                        className={classes.filterCategoryItem}
                        onClick={() => {
                          setSelectedCategory("staff");
                          setTempStaff(activeFilters.staffFilter);
                        }}
                      >
                        <Text>Staff Name</Text>
                        {activeFilters.staffFilter && (
                          <Box className={classes.activeFilterDot} />
                        )}
                      </Box>
                    </Box>
                    <Box className={classes.btn_container}>
                      <Button
                        size="sm"
                        radius={"md"}
                        color="gray"
                        variant="outline"
                        onClick={handleResetAllFilters}
                      >
                        Reset All
                      </Button>
                    </Box>
                  </>
                ) : (
                  <>
                    <Box
                      className={classes.filterCategoryHeader}
                      onClick={() => setSelectedCategory(null)}
                    >
                      <IoChevronBack size={16} />
                      <Text weight={600}>
                        {selectedCategory === "dateRange" && "Date Range"}
                        {selectedCategory === "facility" && "Facility Name"}
                        {selectedCategory === "client" && "Client Name"}
                        {selectedCategory === "taskType" && "Task Type"}
                        {selectedCategory === "staff" && "Staff Name"}
                      </Text>
                    </Box>
                    <Box className={classes.box_body}>
                      {selectedCategory === "dateRange" && (
                        <>
                          <Box className={classes.filterFields}>
                            <DatePickerInput
                              size="sm"
                              radius={"md"}
                              clearable
                              type="range"
                              value={dateRangeVal}
                              disabled={oneDayValue}
                              label="Select Date Range"
                              onChange={handleDateRange}
                              placeholder="Select Date Range"
                            />
                          </Box>
                          <Box className={classes.filterFields}>
                            <DatePickerInput
                              radius={"md"}
                              clearable
                              size="sm"
                              value={oneDayValue}
                              label="Select Date"
                              placeholder="Select Date"
                              onChange={handleDateChange}
                              disabled={dateRangeVal?.length}
                            />
                          </Box>
                        </>
                      )}
                      {selectedCategory === "facility" && (
                        <Box className={classes.filterFields}>
                          <Select
                            label="Select Facility"
                            placeholder="Search facility..."
                            searchable
                            clearable
                            value={tempFacility}
                            onChange={setTempFacility}
                            data={
                              allDeletedFacilities?.facilities
                              ?.filter(
                                (p) => p?.active === true && p?.deleted === false,
                              )
                              ?.map((f) => ({
                                label: f?.name,
                                value: f?.id,
                              })) || []
                            }
                          />
                        </Box>
                      )}
                      {selectedCategory === "client" && (
                        <Box className={classes.filterFields}>
                          <Select
                            label="Select Client"
                            placeholder="Search client..."
                            searchable
                            clearable
                            value={tempClient}
                            onChange={setTempClient}
                            data={
                              allPatients
                              ?.filter(
                                (p) => p?.active === true && p?.deleted === false,
                              )
                              ?.map((p) => ({
                                label: p?.name || "Unknown",
                                value: p?.id,
                              })) || []
                            }
                          />
                        </Box>
                      )}
                      {selectedCategory === "taskType" && (
                        <Box className={classes.filterFields}>
                          <Select
                            label="Select Task Type"
                            placeholder="Search task type..."
                            searchable
                            clearable
                            value={tempTaskType}
                            onChange={setTempTaskType}
                            data={
                              taskTypes
                              ?.map((t) => ({
                                label: t?.name,
                                value: t?.id,
                              })) || []
                            }
                          />
                        </Box>
                      )}
                      {selectedCategory === "staff" && (
                        <Box className={classes.filterFields}>
                          <Select
                            label="Select Staff"
                            placeholder="Search staff..."
                            searchable
                            clearable
                            value={tempStaff}
                            onChange={setTempStaff}
                            data={
                              allStaff
                              ?.filter(
                                (p) => p?.active === true && p?.deleted === false,
                              )
                              ?.map((s) => ({
                                label:
                                  s?.name ||
                                  `${s?.firstName || ""} ${
                                    s?.lastName || ""
                                  }`.trim(),
                                value: s?.id,
                              })) || []
                            }
                          />
                        </Box>
                      )}
                    </Box>
                    <Box className={classes.btn_container}>
                      <Button
                        size="sm"
                        radius={"md"}
                        color="gray"
                        variant="outline"
                        onClick={() => {
                          if (selectedCategory === "dateRange") {
                            setDateRangeVal([]);
                            setOneDayValue(null);
                          }
                          if (selectedCategory === "facility")
                            setTempFacility(null);
                          if (selectedCategory === "client")
                            setTempClient(null);
                          if (selectedCategory === "taskType")
                            setTempTaskType(null);
                          if (selectedCategory === "staff") setTempStaff(null);
                        }}
                      >
                        Reset
                      </Button>
                      <Button
                        radius={"md"}
                        size="sm"
                        onClick={handleApplyFilter}
                        style={{
                          backgroundColor: "var(--app-primary)",
                        }}
                      >
                        Apply
                      </Button>
                    </Box>
                  </>
                )}
              </Menu.Dropdown>
            </Menu>
          </Box>
          <AddButton title={"Add New Task"} onClick={open} />
          <Menu
            classNames={{
              dropdown: classes.menuDropdown,
              item: classes.menuDropdownItem,
            }}
          >
            <Menu.Target>
              <Flex gap={12} className={classes.createMenuBtn}>
                <Text ff="Inter" fz={16} fw={600} color="var(--app-on-primary)">
                  Create Report
                </Text>
                <Box className="arrowBox">
                  <IoIosArrowDown size={24} color="var(--app-on-primary)" />
                </Box>
              </Flex>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item
                fz={14}
                fw={600}
                ff="Inter"
                color="var(--app-text)"
                onClick={() => openReportDrawer("task")}
              >
                Task Report
              </Menu.Item>
              <Menu.Item
                fz={14}
                fw={600}
                ff="Inter"
                color="var(--app-text)"
                onClick={() => openReportDrawer("form8615")}
              >
                Form 8615
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>

          {(profile?.user?.type !== "staff" ||
            (profile?.user?.type === "staff" &&
              profile?.user?.role === "admin")) && (
            <IconSettingsPlus
              color="var(--app-on-primary)"
              stroke={1}
              className={classes.btnIcon}
              size={40}
              onClick={() => navigate("/home/taskType")}
            />
          )}
        </Box>
        {hasActiveFilters && (
          <Box className={classes.activeFiltersBar}>
            {activeFilters.dateRange && (
              <Box className={classes.filterChip}>
                <Text size="xs">
                  Date: {formatDateRange(activeFilters.dateRange)}
                </Text>
                <RxCross2
                  size={12}
                  onClick={() => handleRemoveFilter("dateRange")}
                />
              </Box>
            )}
            {activeFilters.facility && (
              <Box className={classes.filterChip}>
                <Text size="xs">
                  Facility: {getFacilityName(activeFilters.facility)}
                </Text>
                <RxCross2
                  size={12}
                  onClick={() => handleRemoveFilter("facility")}
                />
              </Box>
            )}
            {activeFilters.client && (
              <Box className={classes.filterChip}>
                <Text size="xs">
                  Client: {getClientName(activeFilters.client)}
                </Text>
                <RxCross2
                  size={12}
                  onClick={() => handleRemoveFilter("client")}
                />
              </Box>
            )}
            {activeFilters.taskType && (
              <Box className={classes.filterChip}>
                <Text size="xs">
                  Task Type: {getTaskTypeName(activeFilters.taskType)}
                </Text>
                <RxCross2
                  size={12}
                  onClick={() => handleRemoveFilter("taskType")}
                />
              </Box>
            )}
            {activeFilters.staffFilter && (
              <Box className={classes.filterChip}>
                <Text size="xs">
                  Staff: {getStaffName(activeFilters.staffFilter)}
                </Text>
                <RxCross2
                  size={12}
                  onClick={() => handleRemoveFilter("staffFilter")}
                />
              </Box>
            )}
            <Text
              className={classes.clearAllLink}
              onClick={handleResetAllFilters}
            >
              Clear all
            </Text>
          </Box>
        )}
        <Box className={classes.tableWrapper}>
          <TaskTable currentPage={currentPage} activeFilters={activeFilters} />
          <CustomPagination
            data={tasksCount}
            itemsPerPage={10}
            currentPage={currentPage}
            handlePageChange={handlePageChange}
          />
        </Box>
        {/* <AddTaskReport
          opened={openedReport}
          onclose={reportCloseModal}
          title={"Create New Report"}
        /> */}
        <TaskReportDrawer
          drawerOpen={TaskReportDrawerOpened}
          drawerClose={TaskReportDrawerClose}
          reportType={reportType}
        />
      </Box>
      )}

      {false && (
      /* ══════ Staff Tab — moved to Command Center Operations ══════ */
      <Box px={20} mt={0} style={{ background: "var(--app-bg)", paddingTop: 20, paddingBottom: 30 }}>
        {/* Stats cards — powered by weekly board data */}
        <SimpleGrid cols={4} mb={24}>
          <Paper className={classes.opStatCard}>
            <Box className={classes.opStatAccent} style={{ background: `linear-gradient(180deg, ${getScoreColor(weeklyBoard?.summary?.score ?? 0)}, ${getScoreColor(weeklyBoard?.summary?.score ?? 0)}66)` }} />
            <Flex align="center" gap={12} mb={10} ml={8}>
              <Box className={classes.opStatIconWrap} style={{ background: `${getScoreColor(weeklyBoard?.summary?.score ?? 0)}15` }}>
                <IconChartBar size={20} color={getScoreColor(weeklyBoard?.summary?.score ?? 0)} />
              </Box>
              <Text className={classes.scoreCardTitle} style={{ marginBottom: 0 }}>Weekly Completion</Text>
            </Flex>
            <Text className={classes.scoreCardValue} color={getScoreColor(weeklyBoard?.summary?.score ?? 0)} ml={8}>
              {weeklyBoard?.summary?.score ?? 0}%
            </Text>
            <Box className={classes.scoreBar} ml={8}>
              <Box style={{ height: "100%", width: `${weeklyBoard?.summary?.score ?? 0}%`, borderRadius: 4, background: `linear-gradient(90deg, ${getScoreColor(weeklyBoard?.summary?.score ?? 0)}, ${getScoreColor(weeklyBoard?.summary?.score ?? 0)}88)`, transition: "width 0.6s ease" }} />
            </Box>
          </Paper>

          <Paper className={classes.opStatCard}>
            <Box className={classes.opStatAccent} style={{ background: "linear-gradient(180deg, #10B981, #10B98166)" }} />
            <Flex align="center" gap={12} mb={10} ml={8}>
              <Box className={classes.opStatIconWrap} style={{ background: "#10B98115" }}>
                <IconChecklist size={20} color="#10B981" />
              </Box>
              <Text className={classes.scoreCardTitle} style={{ marginBottom: 0 }}>Completed</Text>
            </Flex>
            <Text className={classes.scoreCardValue} color="#10B981" ml={8}>{weeklyBoard?.summary?.completedAssignments ?? 0}</Text>
          </Paper>

          <Paper className={`${classes.opStatCard}${(weeklyBoard?.summary?.overdue ?? 0) > 0 ? ` ${classes.opOverduePulse}` : ""}`}>
            <Box className={classes.opStatAccent} style={{ background: "linear-gradient(180deg, #EF4444, #EF444466)" }} />
            <Flex align="center" gap={12} mb={10} ml={8}>
              <Box className={classes.opStatIconWrap} style={{ background: "#EF444415" }}>
                <IconUrgent size={20} color="#EF4444" />
              </Box>
              <Text className={classes.scoreCardTitle} style={{ marginBottom: 0 }}>Overdue</Text>
            </Flex>
            <Text className={classes.scoreCardValue} color="#EF4444" ml={8}>{weeklyBoard?.summary?.overdue ?? 0}</Text>
          </Paper>
        </SimpleGrid>

        {/* Sub-tab navigation: All Tasks | Board */}
        <Flex align="center" justify="space-between" mb={16}>
          <Flex align="center" gap={0}>
            <Box
              onClick={() => setStaffSubTab("all")}
              style={{
                padding: "8px 20px",
                borderBottom: staffSubTab === "all" ? "2px solid var(--app-primary)" : "2px solid transparent",
                cursor: "pointer",
                fontFamily: "Inter",
                fontSize: 14,
                fontWeight: staffSubTab === "all" ? 600 : 500,
                color: staffSubTab === "all" ? "var(--app-text)" : "var(--app-text-muted)",
                transition: "all 0.15s ease",
              }}
            >
              All Tasks
            </Box>
            <Box
              onClick={() => { setStaffSubTab("calendar"); if (!weeklyBoard?.days?.length) loadWeeklyBoard(0); }}
              style={{
                padding: "8px 20px",
                borderBottom: staffSubTab === "calendar" ? "2px solid var(--app-primary)" : "2px solid transparent",
                cursor: "pointer",
                fontFamily: "Inter",
                fontSize: 14,
                fontWeight: staffSubTab === "calendar" ? 600 : 500,
                color: staffSubTab === "calendar" ? "var(--app-text)" : "var(--app-text-muted)",
                transition: "all 0.15s ease",
              }}
            >
              Board
            </Box>
          </Flex>
          <NewAddButton
            title="Add Task"
            icon={<FaPlus />}
            onClick={() => { setEditingStaffTask(null); openStaffEditModal(); }}
            color="var(--app-primary)"
            textColor="var(--app-on-primary)"
            variant="filled"
            borderColor="none"
          />
        </Flex>

        {/* ──── All Tasks View ──── */}
        {staffSubTab === "all" && (
          <>
            <Flex align="center" gap={12} mb={12}>
              <Select
                placeholder="Status"
                data={[
                  { value: "all", label: "All Statuses" },
                  { value: "not_started", label: "Not Started" },
                  { value: "in_progress", label: "In-Progress" },
                  { value: "complete", label: "Complete" },
                ]}
                value={staffTaskFilter}
                onChange={(v) => { setStaffTaskFilter(v); setStaffTaskPage(1); }}
                radius="md"
                size="xs"
                style={{ width: 160 }}
                styles={{ input: { fontFamily: "Inter", fontSize: 13 } }}
              />
            </Flex>
            <Box className={classes.table}>
              <ScrollArea>
                <Table withBorder fontSize="sm" verticalSpacing="md">
                  <thead>
                    <tr>
                      <th style={{ minWidth: 200, fontFamily: "Inter", fontSize: 12, fontWeight: 600, color: "var(--app-text-muted)", textTransform: "uppercase", letterSpacing: "0.04em" }}>Title</th>
                      <th style={{ minWidth: 200, fontFamily: "Inter", fontSize: 12, fontWeight: 600, color: "var(--app-text-muted)", textTransform: "uppercase", letterSpacing: "0.04em" }}>Assigned Staff</th>
                      <th style={{ minWidth: 100, fontFamily: "Inter", fontSize: 12, fontWeight: 600, color: "var(--app-text-muted)", textTransform: "uppercase", letterSpacing: "0.04em" }}>Task Type</th>
                      <th style={{ minWidth: 100, fontFamily: "Inter", fontSize: 12, fontWeight: 600, color: "var(--app-text-muted)", textTransform: "uppercase", letterSpacing: "0.04em" }}>Schedule</th>
                      <th style={{ minWidth: 220, fontFamily: "Inter", fontSize: 12, fontWeight: 600, color: "var(--app-text-muted)", textTransform: "uppercase", letterSpacing: "0.04em" }}>Due Date/Time</th>
                      <th style={{ minWidth: 100, fontFamily: "Inter", fontSize: 12, fontWeight: 600, color: "var(--app-text-muted)", textTransform: "uppercase", letterSpacing: "0.04em" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {operationalTasksLoading ? (
                      <tr><td colSpan={6}><Flex justify="center" py={30}><Loader color="var(--app-primary)" size="sm" /></Flex></td></tr>
                    ) : staffTasks.length > 0 ? (
                      staffTasks.map((t, idx) => {
                        const pill = statusPillConfig(t.status, t.isOverdue);
                        const relative = getRelativeTime(t);
                        const isOverdueRow = t.isOverdue && t.status !== "complete";
                        return (
                          <tr
                            key={t._id}
                            className={`${classes.opTableRow}${isOverdueRow ? ` ${classes.opOverdueRow}` : ""}`}
                            style={{ background: isOverdueRow ? undefined : (idx % 2 === 0 ? "var(--app-surface)" : "var(--app-surface-2)") }}
                          >
                            <td>
                              <Text fz={14} fw={500} ff="Inter" color="var(--app-text)">{t.title}</Text>
                              {t.description && <Text fz={12} color="dimmed" ff="Inter" lineClamp={1}>{t.description}</Text>}
                            </td>
                            <td>
                              <Flex gap={6} align="center" wrap="nowrap">
                                {(t.staff || []).slice(0, 1).map((s) => {
                                  const initials = `${(s.firstName || "")[0] || ""}${(s.lastName || "")[0] || ""}`.toUpperCase();
                                  const fullName = `${s.firstName || ""} ${s.lastName || ""}`.trim();
                                  return (
                                    <Box key={s._id} className={classes.opStaffAvatar} style={{ flexShrink: 0 }}>
                                      <Box className={classes.opStaffInitial} style={{ background: getAvatarColor(fullName) }}>{initials}</Box>
                                      {fullName}
                                    </Box>
                                  );
                                })}
                                {(t.staff || []).length > 1 && (
                                  <Popover width={240} position="bottom-start" shadow="md" withArrow>
                                    <Popover.Target>
                                      <Box className={classes.opStaffAvatar} style={{ cursor: "pointer", borderColor: "#F59E0B", background: "#FFFBEB", flexShrink: 0 }}>
                                        <Box className={classes.opStaffInitial} style={{ background: "#F59E0B" }}>+{(t.staff || []).length - 1}</Box>
                                        more
                                      </Box>
                                    </Popover.Target>
                                    <Popover.Dropdown style={{ padding: 12 }}>
                                      <Text ff="Inter" fz={12} fw={700} c="#374151" mb={8}>All Assigned Staff ({(t.staff || []).length})</Text>
                                      <Box style={{ maxHeight: 360, overflowY: "auto" }}>
                                        {(t.staff || []).map((s) => {
                                          const fullName = `${s.firstName || ""} ${s.lastName || ""}`.trim();
                                          const initials = `${(s.firstName || "")[0] || ""}${(s.lastName || "")[0] || ""}`.toUpperCase();
                                          return (
                                            <Flex key={s._id} align="center" gap={8} mb={6}>
                                              <Box style={{ width: 26, height: 26, borderRadius: "50%", backgroundColor: getAvatarColor(fullName), display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                                <Text ff="Inter" fz={9} fw={700} c="#fff">{initials}</Text>
                                              </Box>
                                              <Text ff="Inter" fz={12} fw={500} c="#374151">{fullName}</Text>
                                            </Flex>
                                          );
                                        })}
                                      </Box>
                                    </Popover.Dropdown>
                                  </Popover>
                                )}
                              </Flex>
                            </td>
                            <td>
                              {t.taskType === "system" ? (
                                <Box className={classes.opTaskTypeBadge} style={{ background: "#EFF6FF", color: "#2563EB" }}>System Task</Box>
                              ) : (
                                <Box className={classes.opTaskTypeBadge} style={{ background: "var(--app-tint-purple)", color: "var(--app-ink-purple)" }}>Admin Task</Box>
                              )}
                            </td>
                            <td>
                              <Badge color={t.scheduleType === "recurring" ? "violet" : "cyan"} variant="light" size="sm">
                                {t.scheduleType === "recurring" ? "Recurring" : "One Time"}
                              </Badge>
                            </td>
                            <td>
                              <Flex align="center" gap={0} wrap="nowrap">
                                <Text fz={13} ff="Inter" color="#374151" style={{ whiteSpace: "nowrap" }}>{opScheduleLabel(t)}</Text>
                                {relative && (
                                  <Text component="span" className={classes.opRelativeTime} color={relative.overdue ? "#EF4444" : "#9CA3AF"} style={{ whiteSpace: "nowrap" }}>
                                    {" \u00B7 "}{relative.text}
                                  </Text>
                                )}
                              </Flex>
                            </td>
                            <td>
                              <Group spacing={4}>
                                <ActionIcon size="sm" variant="subtle" color="blue" onClick={() => openEditTask(t)}><IconEdit size={15} /></ActionIcon>
                                <ActionIcon size="sm" variant="subtle" color="red" onClick={() => handleStaffTaskDelete(t._id)}><IconTrash size={15} /></ActionIcon>
                              </Group>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr><td colSpan={6}><RecordNotFound /></td></tr>
                    )}
                  </tbody>
                </Table>
              </ScrollArea>
              <CustomBillingPagination data={operationalTasksCount} itemsPerPage={10} currentPage={staffTaskPage} handlePageChange={(p) => setStaffTaskPage(p)} />
            </Box>
          </>
        )}

        {/* ──── Board / Board View ──── */}
        {staffSubTab === "calendar" && (
          <Box>
            {/* Week navigation */}
            <Flex align="center" justify="space-between" mb={16}>
              <Flex align="center" gap={10}>
                <ActionIcon variant="subtle" size="md" onClick={() => { setWeekOffset(o => o - 1); loadWeeklyBoard(weekOffset - 1); }}>
                  <IconChevronLeft size={18} />
                </ActionIcon>
                <Text ff="Inter" fz={15} fw={600} c="#374151">
                  {weeklyBoard?.weekStart ? new Date(weeklyBoard.weekStart).toLocaleDateString("en-US", { month: "short", day: "numeric" }) : ""} — {weeklyBoard?.weekEnd ? new Date(weeklyBoard.weekEnd).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : ""}
                </Text>
                <ActionIcon variant="subtle" size="md" onClick={() => { setWeekOffset(o => o + 1); loadWeeklyBoard(weekOffset + 1); }}>
                  <IconChevronRight size={18} />
                </ActionIcon>
                {weekOffset !== 0 && (
                  <Box
                    onClick={() => { setWeekOffset(0); loadWeeklyBoard(0); }}
                    style={{ cursor: "pointer", fontFamily: "Inter", fontSize: 12, fontWeight: 600, color: "var(--app-primary)", padding: "4px 10px", borderRadius: 6, background: "#FFF8EC", border: "1px solid #FFE4A8" }}
                  >
                    Today
                  </Box>
                )}
              </Flex>
            </Flex>

            {weeklyBoardLoading ? (
              <Flex justify="center" py={60}><Loader color="var(--app-primary)" size="md" /></Flex>
            ) : (
              <Box style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 10, minHeight: 480 }}>
                {(weeklyBoard?.days || []).map((day) => {
                  const isToday = day.isToday;
                  const dayTasks = day.tasks || [];
                  const totalStaffEntries = dayTasks.reduce((acc, t) => acc + (Array.isArray(t.staffCompletions) ? t.staffCompletions.length : 0), 0);
                  const completedEntries = dayTasks.reduce((acc, t) => acc + (Array.isArray(t.staffCompletions) ? t.staffCompletions : []).filter(sc => sc.status === "complete").length, 0);
                  const dayScore = totalStaffEntries > 0 ? Math.round((completedEntries / totalStaffEntries) * 100) : null;

                  return (
                    <Paper
                      key={day.date}
                      p={0}
                      radius="md"
                      style={{
                        border: isToday ? "2px solid var(--app-primary)" : "1px solid var(--app-border)",
                        background: isToday ? "#FFFDF7" : "var(--app-surface)",
                        overflow: "hidden",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      {/* Day header */}
                      <Box style={{
                        padding: "10px 12px 8px",
                        background: isToday ? "linear-gradient(135deg, #FFF8EC, #FFF2D4)" : "var(--app-surface-2)",
                        borderBottom: "1px solid var(--app-border)",
                      }}>
                        <Text ff="Inter" fz={11} fw={700} color={isToday ? "#D97706" : "var(--app-text-muted)"} tt="uppercase" lts={0.5}>
                          {day.dayName}
                        </Text>
                        <Flex align="center" justify="space-between">
                          <Text ff="Inter" fz={16} fw={isToday ? 800 : 600} color={isToday ? "#171717" : "#374151"}>
                            {new Date(day.date + "T12:00:00").getDate()}
                          </Text>
                          {dayScore !== null && (
                            <Box style={{
                              fontSize: 11, fontWeight: 700, fontFamily: "Inter",
                              color: dayScore >= 80 ? "#10B981" : dayScore >= 50 ? "#F59E0B" : "#EF4444",
                              background: dayScore >= 80 ? "#ECFDF5" : dayScore >= 50 ? "#FFFBEB" : "#FEF2F2",
                              padding: "2px 8px", borderRadius: 10,
                            }}>
                              {dayScore}%
                            </Box>
                          )}
                        </Flex>
                      </Box>

                      {/* Task list for the day */}
                      <Box style={{ flex: 1, padding: "8px 10px", overflowY: "auto" }}>
                        {dayTasks.length === 0 ? (
                          <Text ff="Inter" fz={11} c="var(--app-text-muted)" ta="center" mt={20}>No tasks</Text>
                        ) : (
                          dayTasks.map((task) => (
                            <Box
                              key={task._id}
                              mb={6}
                              onClick={() => openEditTask(task)}
                              style={{
                                padding: "8px 10px",
                                borderRadius: 8,
                                background: "var(--app-surface-2)",
                                border: "1px solid var(--app-border)",
                                cursor: "pointer",
                                transition: "all 0.15s ease",
                              }}
                              sx={{
                                "&:hover": {
                                  background: "#FFF8EC",
                                  borderColor: "#FFE4A8",
                                  transform: "translateY(-1px)",
                                  boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                                },
                              }}
                            >
                              <Text ff="Inter" fz={12} fw={600} c="#374151" lineClamp={1} mb={4}>{task.title}</Text>
                              {/* Per-staff completion chips */}
                              <Flex gap={4} wrap="wrap">
                                {(Array.isArray(task.staffCompletions) ? task.staffCompletions : []).map((sc) => {
                                  const staff = sc.staff || {};
                                  const initials = `${(staff.firstName || "")[0] || ""}${(staff.lastName || "")[0] || ""}`.toUpperCase();
                                  const isComplete = sc.status === "complete";
                                  const isMissed = sc.status === "missed";
                                  return (
                                    <Tooltip
                                      key={staff._id || Math.random()}
                                      label={`${staff.firstName || ""} ${staff.lastName || ""} — ${sc.status === "complete" ? "Completed" : sc.status === "missed" ? "Missed" : sc.status === "in_progress" ? "In Progress" : "Not Started"}`}
                                      withArrow
                                      position="top"
                                    >
                                      <Box style={{
                                        width: 26, height: 26, borderRadius: "50%",
                                        display: "flex", alignItems: "center", justifyContent: "center",
                                        fontSize: 9, fontWeight: 700, fontFamily: "Inter",
                                        color: isComplete ? "#fff" : isMissed ? "#fff" : "#6B7280",
                                        background: isComplete ? "#10B981" : isMissed ? "#EF4444" : "#E5E7EB",
                                        border: isComplete ? "2px solid #059669" : isMissed ? "2px solid #DC2626" : "2px solid #D1D5DB",
                                        cursor: "default",
                                        flexShrink: 0,
                                      }}>
                                        {isComplete ? <IconCheck size={12} /> : initials}
                                      </Box>
                                    </Tooltip>
                                  );
                                })}
                              </Flex>
                            </Box>
                          ))
                        )}
                      </Box>
                    </Paper>
                  );
                })}
              </Box>
            )}

            {/* Staff Weekly Summary removed — tasks are clickable on the board */}
          </Box>
        )}
      </Box>
      )}

      {/* ── Staff Task Edit Modal (shared component) ── */}
      <ComplianceTaskModal
        opened={staffEditModalOpened}
        onClose={() => { closeStaffEditModal(); setEditingStaffTask(null); }}
        editTask={editingStaffTask}
        addLoading={false}
        allStaff={allStaff}
        onSaved={() => getOperationalTasks(staffTaskPage, 10, staffTaskFilter, staffTaskSearch)}
      />
    </Box>
  );
};

export default AllTasks;
